import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '@/axios';

interface VerifyInviteTokenParams {
  token: string;
}

interface VerifyInviteTokenResponse {
  success: boolean;
  message?: string;
  data?: {
    email?: string;
    uid?: string;
  };
}

// v3-verifyInviteToken to onRequest (POST), nie callable — stąd axios zamiast
// httpsCallable. Wcześniej hook wołał callable `verifyInviteTokenEndpoint`,
// który zniknął przy migracji na v3: wywołanie zawsze rzucało, a ekran resetu
// pokazywał „link wygasł lub został już użyty" dla KAŻDEGO zaproszenia.
export const useVerifyInviteToken = () => useMutation({
  mutationFn: async ({ token }: VerifyInviteTokenParams) => {
    const res = await axiosInstance.post<VerifyInviteTokenResponse>(
      '/v3-verifyInviteToken',
      { token },
      { headers: { 'Content-Type': 'application/json' } },
    );

    if (!res.data?.success || !res.data.data?.uid) {
      throw new Error(res.data?.message || 'Token verification failed');
    }

    return res.data.data;
  },
});
